import axios from "axios"

const state = {
  STATUS: null,
  API_ROUTE: "/admin",
  adminsList: [],
  totalAdmins: 0
}

const getters = {
  adminsList: (state) => state.adminsList,
  totalAdmins: (state) => state.totalAdmins
}

const mutations = {
  setAdmins(state, admins) {
    state.adminsList = admins
  },
  setTotalAdmins(state, total) {
    state.totalAdmins = total
  }
}

const actions = {
  async listAdmins({ commit }, params) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/list/${userId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        params
      }
      const response = await window.axios.get(url, config)
      commit("setAdmins", response.data.admins)
      commit("setTotalAdmins", response.data.total)

      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async listAdminById({ commit }, { id }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/adminById/${userId}/${id}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.get(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async removeAdmin({ commit }, { id }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}/${id}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.delete(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async createAdmin({ commit }, { admin }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.post(url, admin, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      if (error.response && error.response.data.detail.message) {
        throw new Error(error.response.data.detail.message || "An error occurred while saving the admin.")
      }
      throw error
    }
  },
  async updateAdmin({ commit }, { admin, id }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}/${id}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.put(url, admin, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      if (error.response && error.response.data.detail.message) {
        throw new Error(error.response.data.detail.message || "An error occurred while updating the admin.")
      }
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
